<form class="" #termsForm="ngForm" action="javascript:">
  <div class="row">
    <div class="col-sm-12">
      <app-card [title]="'admin.dealer_dashboard.add.block_details'|translate">
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="title">{{"doctrine.dealer_dashboard.title" | translate}}<span class="star">*</span></label>
              <input name="title"
                     id="title"
                     class="form-control"
                     required
                     [(ngModel)]="block.title">
              <span class="form-bar"></span>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label for="language">{{"doctrine.dealer_dashboard.user_status" | translate}}<span
                class="star">*</span></label>
              <ng-select required name="userStatus" id="userStatus" [items]="user_statuses" bindValue="value" [disabled]="block.locked"
                         [(ngModel)]="block.userStatus" [clearable]="false" [searchable]="false"></ng-select>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label for="language">{{"doctrine.dealer_dashboard.language" | translate}}<span
                class="star">*</span></label>
              <ng-select required name="language" id="language" [items]="languages" bindValue="value" [disabled]="block.locked"
                         [(ngModel)]="block.language" [clearable]="false" [searchable]="false"></ng-select>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label for="status">{{"global.status" | translate}}<span class="star">*</span></label>
              <ng-select required name="status" id="status" [items]="status" bindValue="value"
                         [(ngModel)]="block.status" [clearable]="false" [searchable]="false"></ng-select>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label for="status">{{"doctrine.invoice_dealer.profile" | translate}}<span class="star">*</span></label>
              <ng-select required name="profiles" id="profiles" [items]="profiles" bindValue="value" [multiple]="true"
                         [(ngModel)]="block.profiles" [clearable]="false" [searchable]="false"></ng-select>
            </div>
          </div>
          <div class="col-3" *ngIf="block.locked">
            <div class="form-group">
              <label for="statuses">{{"doctrine.dealer_profile.order_statuses" | translate}}<span class="star">*</span></label>
              <ng-select [required]="block.locked" name="statuses" id="statuses" [items]="statuses" bindValue="value" [multiple]="true"
                         [(ngModel)]="block.statuses" [clearable]="false" [searchable]="false"></ng-select>
            </div>
          </div>
          <div class="col-3" *ngIf="block.locked">
            <div class="form-group">
              <label for="suppliers">{{"menu.collections.suppliers" | translate}}<span class="star">*</span></label>
              <ng-select [required]="block.locked" name="suppliers" id="suppliers" [items]="suppliers" bindValue="value" [multiple]="true"
                         [(ngModel)]="block.suppliers" [clearable]="false" [searchable]="false"></ng-select>
            </div>
          </div>
        </div>
        <div class="row mb-5">
          <label for="content">{{"doctrine.dealer_dashboard.content" | translate}}   <span
            class="star">*</span></label>
          <quill-editor required #editor="ngModel" [modules]="modules" name="content"
                        [(ngModel)]="block.content" [strict]="true" id="content"
                        (onEditorCreated)="onEditorCreated($event)"
          ></quill-editor>
          <div class="messages text-danger"
                *ngIf="editor.invalid && editor.dirty && editor.errors?.required">{{'errors.required'|translate}}
          </div>
        </div>
        <br>
        <br>
        <div class="row">
          <div class="col-12">
            <div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
              <div class="text-end">
                <button (click)="submitItem(false)" class="btn btn-link"
                        type="button">{{'global.cancel'|translate}}</button>
                <button type="button" class="btn btn-primary ripple light"
                        [disabled]="termsForm.invalid"
                        (click)="submitItem(true)">{{(isEdit ? 'global.actions.save' : 'global.add')|translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </app-card>
    </div>
  </div>
</form>
<app-modal-basic #inputModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.dealer_dashboard.input' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="cancelInput()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form #inputForm="ngForm">
      <!-- Enter link address -->
      <div class="form-group" *ngIf="'link'===(modalHandler | async)">
        <label for="link_address">{{"admin.dealer_dashboard.enter_link_address" | translate}}<span class="star">*</span></label>
        <input name="link_address"
               id="link_address"
               class="form-control"
               placeholder="https://urbansofa.nl"
               required
               [(ngModel)]="input_address">
        <span class="form-bar"></span>
      </div>
      <!-- END enter link address -->
      <!-- Upload  -->
      <div class="form-group"
           *ngIf="'image'===(modalHandler | async) || 'video'===(modalHandler | async)|| 'file'===(modalHandler | async)">
        <label for="uploaderFile">{{'global.upload'| translate }}</label>
        <label class="custom-file">
          <input type="file" *ngIf="'video'===(modalHandler | async)" #uploadEl ng2FileSelect [uploader]="uploader" class="custom-file-input form-control"
                 id="uploaderVideo" (change)="fileChange($event)" accept="video/*">

          <input type="file" *ngIf="'image'===(modalHandler | async)" #uploadEl ng2FileSelect [uploader]="uploader" class="custom-file-input form-control"
                 id="uploaderImage" (change)="fileChange($event)" accept=".png, .jpeg, .gif, .jpg, .svg, .webp">

          <input type="file" *ngIf="'file'===(modalHandler | async)" #uploadEl ng2FileSelect [uploader]="uploader" class="custom-file-input form-control"
                 id="uploaderFile" (change)="fileChange($event)" accept="application/*">
          <span class="custom-file-control-upload btn-sm "
                *ngIf="uploader.queue.length==0">{{"global.choose_file"|translate}}</span>
          <span class="custom-file-control-upload btn-sm "
                *ngIf="uploader.queue.length>0">{{"global.change_file"|translate}}</span>
          <span
            class="custom-file-control">{{(uploader.queue.length > 0) ? uploader.queue[uploader.queue.length - 1].file.name : ''}}</span>
        </label>
        <div class="row mt-3">
          <!--
          Change Button -->
          <div *ngIf="fileUrl" class="col-sm-8">
            <button (click)="uploadImage()"
                    class="btn btn-primary btn-sm waves-effect waves-light text-nowrap me-2">{{'global.upload'|translate}}</button>
          </div>
        </div>
        <div class="row" *ngIf="isUploading">
          <div class="col-sm-12">
            <!-- Loading Style -->
            <div class="preloader3 loader-block mx-auto">
              <div class="circ1 loader-success"></div>
              <div class="circ2 loader-success"></div>
              <div class="circ3 loader-success"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- END Upload -->
      <!-- Enter image address -->
      <div class="form-group" *ngIf="'image'===(modalHandler | async)">
        <label for="link_address">{{"admin.dealer_dashboard.enter_image_address" | translate}}<span
          class="star">*</span></label>
        <input name="image_address"
               id="image_address"
               class="form-control"
               placeholder="https://urbansofa.nl/logo.png"
               required
               [(ngModel)]="input_address"
        pattern="^https?.+(\.png|\.jpeg|\.gif|\.jpg|\.svg|\.webp)$">
        <span class="form-bar"></span>
      </div>
      <!-- END Enter image address -->
      <!-- Enter video address -->
      <div class="form-group" *ngIf="'video'===(modalHandler | async)">
        <label for="link_address">{{"admin.dealer_dashboard.enter_video_address" | translate}}<span
          class="star">*</span></label>
        <input name="video_address"
               id="video_address"
               class="form-control"
               placeholder="https://urbansofa.nl/advertise.mp4"
               required
               [(ngModel)]="input_address">
        <span class="form-bar"></span>
      </div>
      <!-- END Enter video address -->
      <!-- Enter file address -->
      <div class="form-group" *ngIf="'file'===(modalHandler | async)">
        <label for="link_address">{{"admin.dealer_dashboard.enter_file_address" | translate}}<span
          class="star">*</span></label>
        <input name="file_address"
               id="file_address"
               class="form-control"
               placeholder="https://urbansofa.nl/invoice.pdf"
               required
               [(ngModel)]="input_address">
        <span class="form-bar"></span>
      </div>
      <!-- END Enter file address -->
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="cancelInput()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="acceptInput()" [disabled]="inputForm.invalid">{{'global.ok'|translate}}</button>
  </div>
</app-modal-basic>
